export default __webpack_public_path__ + "static/media/guide_to_prosperity.1679d59b.png";